export const ContentErrorFallback = () => {
  const isProduction = process.env.NODE_ENV === "production";

  return (
    <div className="builder-component-error-fallback" style={isProduction ? { display: "none" } : {}}>
      <span>Builder component could not be rendered due to internal component error</span>
    </div>
  );
};
